import { render, staticRenderFns } from "./svg-file-picker.vue?vue&type=template&id=07ebd0f8&scoped=true"
import script from "./svg-file-picker.vue?vue&type=script&lang=js"
export * from "./svg-file-picker.vue?vue&type=script&lang=js"
import style0 from "./svg-file-picker.vue?vue&type=style&index=0&id=07ebd0f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ebd0f8",
  null
  
)

export default component.exports